import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  LinearScale,
  TimeScale,
  Tooltip,
  Title,
  Legend,
} from "chart.js";

import "chartjs-adapter-date-fns";

ChartJS.register(BarElement, LinearScale, TimeScale, Tooltip, Title, Legend);

export default function PaymentsOverTimeChart({ data }) {
  const hasData = data.length > 0;

  const chartData = {
    datasets: [
      {
        label: "Payments Over Time",
        data: data.map(item => ({
          x: new Date(item.date),
          y: item.totalAmount,
        })),
        backgroundColor: "#7b1fa2",
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      x: {
        type: "time",
        time: {
          unit: "hour", 
        },
        title: {
          display: true,
          text: "Date",
        },
        ticks: {
          maxRotation: 45,
          autoSkip: true,
        },
      },
      y: {
        title: {
          display: true,
          text: "Total Payment Amount",
        },
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        position: "top",
      },
    },
  };

  return (
    <div className="chartCard">
      <h3>Payments Over Time</h3>
      {hasData ? (
        <Bar data={chartData} options={options} />
      ) : (
        <p style={{ textAlign: "center", color: "#666" }}>
          No payment trend data available
        </p>
      )}
    </div>
  );
}
